/**
 * @fileOverview
 * Demo Application
 */
import React from 'react';
import { HashRouter as ReactRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { setupFDS } from '@tcc/fds';
import { AppRouter } from './router/AppRouter/AppRouter';
import { getGraphQlClient } from './graphql/graphqlClient';
import './utils/datadog';
import { renderUsingContextVersion } from './utils/renderUsingContextVersion';

declare global {
  interface Window {
    timerStart: number;
    timeEvents: {
      fieldView: {
        appStart: number;
      };
    };
  }
}

window.timerStart = Date.now();
setupFDS();
const graphQlClient = getGraphQlClient();

const App = () =>
  (
    <ApolloProvider client={graphQlClient}>
      <ReactRouter>
        <AppRouter />
      </ReactRouter>
    </ApolloProvider>
  );

renderUsingContextVersion(<App />, document.getElementById('root'));
